import { useState, useEffect } from 'react';

export const useDebounceVariable = (value: boolean, delay: number): boolean => {
  const [debouncedValue, setDebouncedValue] = useState(false);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};
